import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { List } from 'linqts';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import {
  IResponseDto,
  IAuthUserDto,
  IAttendanceDto,
  IAttendanceOnlyDto,
  INotificationDto,
  ITimeTableDto,
  ICircularDto,
  IStudentBaseDto,
  IStudentDto,
  IStudentFeeDto,
  ISchoolHolidaysDto,
  IExamNamesDto,
  IEventTypeDto,
  IEventNamesDto,
  IEventImagesDto,
  IChangePasswordDto,
  IReminderDto,
  IForgotPasswordDto,
  IPaymentHistoryDto,
  ISchoolConfigurationDto,
  IFeeInvoiceDto,
  IPushRegDto,
} from '../models/common.models';
import { Key, promise } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  clientId = 'app';
  appVersion = '2.2.2';
  // baseUrl = 'https://kalkere.azurewebsites.net/api';
  baseUrl = 'https://api.npskalkere.com/api';
  // baseUrl = 'https://dev.npskalkere.com/api'
  //  baseUrl = 'http://localhost:59952/api';
  authUrl = '/v1/auth';
  attendanceforchartUrl = '/v1/attendance-chart'; // v1/attendance-chart
  attendanceUrl = '/v1/attendence'; // attance by date
  // attendanceBasedOnDateUrl = '/v1/studentattendencebasedondate';
  circularUrl = '/v1/circular';
  announcementsUrl = '/v1/announcements';
  timetableUrl = '/v1/timetable';
  studentsByParentUrl = '/v1/students'; // v1/students
  studentclasssectionUrl = '/v1/class-sections'; // v1/class-sections
  studentfeeUrl = '/v1/academic-fee'; // v1/academic-fee
  calendareventsformobileUrl = '/v1/events-calendar'; // v1/events-calendar event names by date
  studentReportCardUrl = '/v1/report-card'; // v1/report-card
  examnamesUrl = '/v1/term-exams'; // v1/term-exams : exam names
  eventtypesUrl = '/v1/event-types'; // v1/event-types
  eventnamesUrl = '/v1/class-events'; // v1/class-events: get event list by event type
  eventimagesUrl = '/v1/event-photos'; // v1/event-photos
  remindersUrl = '/v1/reminders';
  changepasswordUrl = '/v1/changepassword';
  parentcircularUrl = '/v1/parent-circular';
  parentnotificationUrl = '/v1/parent-notification';
  multiplecircularfilesUrl = '/v1/multiplecircularfiles';
  forgotpwdUrl = '/v1/forgotpwd';
  paymenthistoryUrl = '/v1/paymenthistory';
  paymentreceiptUrl = '/v1/payment-receipt';
  registeruseronesignalUrl = '/v1/registerUOS';
  schoolconfigurationUrl = '/v1/configuration';
  paymentinvoiceUrl = '/v1/payment-invoice';
  private paramData: any;
  constructor(
    private http: HttpClient,
    private storage: Storage,
    public router: Router,
    public commonSvc: CommonService,
  ) {
  }


  // options = { headers: new HttpHeaders().set('apikey', sessionStorage.getItem('apikey')) };
  options = {};
  public async login(loginId: string, pwd: string): Promise<IResponseDto<IAuthUserDto>> {
    const endpoint = `${this.baseUrl}${this.authUrl}?username=${loginId}&pwd=${btoa(pwd)}`;
    return this.http
      .get(endpoint)
      .toPromise()
      .then((res: IResponseDto<IAuthUserDto>) => {
        console.log(res);
        sessionStorage.setItem('apikey', res.data.apiKey);
        return res;
      }).catch((res: IResponseDto<IAuthUserDto>) => {
        console.error('An error occurred:' + endpoint);
        return res;
      });
  }

  public async attendanceforchart(studentId: number): Promise<IResponseDto<IAttendanceOnlyDto>> {
    let endpoint = null;
    endpoint = `${this.baseUrl}${this.attendanceforchartUrl}?studentid=${studentId}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IAttendanceOnlyDto>) => {
        // console.log(res);
        return res;
      });
  }

  public async attendance(studentId: number): Promise<IResponseDto<IAttendanceDto[]>> {
    let endpoint = null;
    if (studentId > 0) {
      endpoint = `${this.baseUrl}${this.attendanceUrl}?studentid=${studentId}`;
    }
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IAttendanceDto[]>) => {
        // console.log(res);
        return res;
      });
  }
  public async announcements(studentId: number): Promise<IResponseDto<INotificationDto[]>> {
    const endpoint = `${this.baseUrl}${this.announcementsUrl}?studentid=${studentId}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<INotificationDto[]>) => {
        // console.log(res);
        return res;
      });
  }

  public async circular(studentId: number): Promise<IResponseDto<ICircularDto[]>> {
    const endpoint = `${this.baseUrl}${this.circularUrl}?studentid=${studentId}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<ICircularDto[]>) => {
        // console.log(res);
        return res;
      });
  }

  public async timetable(classid: number, termName: string, examName: string): Promise<IResponseDto<ITimeTableDto[]>> {
    let endpoint = null;
    if (classid > 0 && termName != null) {
      endpoint = `${this.baseUrl}${this.timetableUrl}?classid=${classid}&termname=${termName}&examname=${examName}`;
    } else {
      endpoint = `${this.baseUrl}${this.timetableUrl}?classid=${classid}`;
    }
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<ITimeTableDto[]>) => {
        // console.log(res);
        return res;
      });
  }
  // public async studentsbasedonparent(parentuserid: string): Promise<IResponseDto<IStudentBaseDto[]>> {
  //   const endpoint = `${this.baseUrl}${this.studentsByParentUrl}?parentuserid=${parentuserid}`;
  //   await this.getapikey();
  //   return this.http
  //     .get(endpoint, this.options)
  //     .toPromise()
  //     .then((res: IResponseDto<IStudentBaseDto[]>) => {
  //       // console.log(res);
  //       return res;
  //     });
  // }
  public async studentclasssectiondetails(studentId: number): Promise<IResponseDto<IStudentDto[]>> {
    const endpoint = `${this.baseUrl}${this.studentclasssectionUrl}?studentid=${studentId}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IStudentDto[]>) => {
        // console.log(res);
        return res;
      });
  }

  public async studentfeedetails(studentId: number): Promise<IResponseDto<IStudentFeeDto>> {
    const endpoint = `${this.baseUrl}${this.studentfeeUrl}?studentid=${studentId}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IStudentFeeDto>) => {
        // console.log(res);
        return res;
      });
  }

  public async studentsbyparent(): Promise<IResponseDto<IStudentBaseDto[]>> {
    const endpoint = `${this.baseUrl}${this.studentsByParentUrl}`;
    console.log(endpoint);
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IStudentBaseDto[]>) => {
        console.log(res);
        return res;
      });
  }
  public async schoolholidays(): Promise<IResponseDto<ISchoolHolidaysDto[]>> {
    const endpoint = `${this.baseUrl}${this.calendareventsformobileUrl}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<ISchoolHolidaysDto[]>) => {
        // console.log(res);
        return res;
      });
  }
  public async studentreportcard(studentid: number, classname: string, scholastic: boolean, termname: string):
    Promise<IResponseDto<string>> {
    // tslint:disable-next-line:max-line-length
    const endpoint = `${this.baseUrl}${this.studentReportCardUrl}?studentid=${studentid}&classname=${classname}&termname=${termname}&scholastic=${scholastic}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<string>) => {
        // console.log(res);
        return res;
      });
  }
  public async examnameslist(termname: string): Promise<IResponseDto<IExamNamesDto[]>> {
    const endpoint = `${this.baseUrl}${this.examnamesUrl}?termname=${termname}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IExamNamesDto[]>) => {
        // console.log(res);
        return res;
      });
  }
  public async eventtypes(): Promise<IResponseDto<IEventTypeDto[]>> {
    const endpoint = `${this.baseUrl}${this.eventtypesUrl}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IEventTypeDto[]>) => {
        // console.log(res);
        return res;
      });
  }
  public async eventnames(eventtypeid: number, classid: number): Promise<IResponseDto<IEventNamesDto[]>> {
    const endpoint = `${this.baseUrl}${this.eventnamesUrl}?eventtypeid=${eventtypeid}&classid=${classid}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IEventNamesDto[]>) => {
        return res;
      });
  }

  public async eventimages(eventid: number): Promise<IResponseDto<IEventImagesDto[]>> {
    const endpoint = `${this.baseUrl}${this.eventimagesUrl}?eventid=${eventid}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IEventImagesDto[]>) => {
        return res;
      });
  }

  public async reminders(classname: string): Promise<IResponseDto<IReminderDto[]>> {
    const endpoint = `${this.baseUrl}${this.remindersUrl}?classname=${classname}`;
    // this.getapikey().then(() => {
    //   this.options = this.options;
    // });
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IReminderDto[]>) => {
        // console.log(res);
        return res;
      });
  }

  public async changePassword(oldpwd: string, newpwd: string, userid: number): Promise<IResponseDto<IChangePasswordDto>> {
    const endpoint = `${this.baseUrl}${this.changepasswordUrl}?oldpassword=${btoa(oldpwd)}&newpassword=${btoa(newpwd)}&userid=${userid}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IChangePasswordDto>) => {
        return res;
      });
  }
  public async parentcircular(circularid: number): Promise<IResponseDto<ICircularDto>> {
    const endpoint = `${this.baseUrl}${this.parentcircularUrl}?circularid=${circularid}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<ICircularDto>) => {
        return res;
      });
  }
  public async parentnotification(notificationid: number): Promise<IResponseDto<INotificationDto>> {
    const endpoint = `${this.baseUrl}${this.parentnotificationUrl}?NotificationID=${notificationid}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<INotificationDto>) => {
        return res;
      });
  }
  public async multiplecircularfiles(circularId: number): Promise<IResponseDto<ICircularDto[]>> {
    const endpoint = `${this.baseUrl}${this.multiplecircularfilesUrl}?circularid=${circularId}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<ICircularDto[]>) => {
        return res;
      });
  }
  public async forgotpwd(phoneno: string): Promise<IResponseDto<IForgotPasswordDto>> {
    const endpoint = `${this.baseUrl}${this.forgotpwdUrl}?phoneno=${phoneno}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IForgotPasswordDto>) => {
        return res;
      });
  }
  public async paymenthistory(studentid: number, classname: string): Promise<IResponseDto<IPaymentHistoryDto[]>> {
    const endpoint = `${this.baseUrl}${this.paymenthistoryUrl}?studentid=${studentid}&classname=${classname}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IPaymentHistoryDto[]>) => {
        return res;
      });
  }

  public async registeruseronesignal(onesignalplayerid: string): Promise<IResponseDto<string>> {
    const endpoint = `${this.baseUrl}${this.registeruseronesignalUrl}?onesignalkey=${onesignalplayerid}`;
    console.log(endpoint);
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<string>) => {
        console.log(res);
        return res;
      });
  }

  public async schoolconfiguration(): Promise<IResponseDto<ISchoolConfigurationDto>> {
    const endpoint = `${this.baseUrl}${this.schoolconfigurationUrl}`;
    console.log(endpoint);
    await this.getapikey();
    return this.http
    .get(endpoint, this.options)
    .toPromise()
    .then((res: IResponseDto<ISchoolConfigurationDto>) => {
      console.log();
      return res;
    });
  }

  public async paymentreceipt(receiptno: string):
    Promise<IResponseDto<string>> {
    // tslint:disable-next-line:max-line-length
    const endpoint = `${this.baseUrl}${this.paymentreceiptUrl}?receiptno=${receiptno}`;
    await this.getapikey();
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<string>) => {
        return res;
      });
  }

  public async paymentinvoice(studentid: number):
    Promise<IResponseDto<IFeeInvoiceDto>> {
    // tslint:disable-next-line:max-line-length
    const endpoint = `${this.baseUrl}${this.paymentinvoiceUrl}?studentId=${studentid}`;
    await this.getapikey();
    console.log(endpoint);
    return this.http
      .get(endpoint, this.options)
      .toPromise()
      .then((res: IResponseDto<IFeeInvoiceDto>) => {
        return res;
      });
  }

  // getapikey() {
  //   this.options = { headers: new HttpHeaders().set('apikey', sessionStorage.getItem('apikey')) };
  // }

  async getapikey() {
    const apiKeyvalue = await this.commonSvc.getItem('apikey');
    if (apiKeyvalue) {
      this.options = { headers: new HttpHeaders().set('apikey', apiKeyvalue) };
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  setParamData(data) {
    this.paramData = data;
  }

  getParamData() {
    return this.paramData;
  }
}
